import { RESET } from '../offlineAvailability/offlineAvailability.actionTypes';
import { ConnectionActionType } from './connection.actionCreators';
import {
	CHANGE_NETWORK_STATE,
	CHUNK_LOADING_ERROR,
	NETWORK_FETCH_REQUEST_ERROR,
	NETWORK_SAVE_REQUEST_ERROR,
} from './connection.actionTypes';

export type XHRConnectionError = {
	url: string;
	method: 'get' | 'put' | 'post' | 'delete' | 'patch';
	withCredentials: boolean;
	timestamp?: string;
};

export type ChunkLoadingErrorType = { error: Error; component: string };

export type ConnectionStateType = {
	readonly online: boolean;
	readonly requestErrors: Array<XHRConnectionError>;
	readonly chunkLoadingErrors: Array<ChunkLoadingErrorType>;
	readonly outgoingSaveRequestFailed?: boolean;
	readonly outgoingFetchRequestFailed?: boolean;
	readonly component?: string;
};

export type RootStateType = {
	connection: ConnectionStateType;
};

// Reducer
// ------------------------------------

export const initialState: ConnectionStateType = {
	online: true, // we assume that the user is online
	outgoingSaveRequestFailed: false,
	outgoingFetchRequestFailed: false,
	requestErrors: [],
	chunkLoadingErrors: [],
};

export default (state: ConnectionStateType = initialState, action: ConnectionActionType): ConnectionStateType => {
	switch (action.type) {
		// FIXME: Not needed? no reference found
		case RESET as any:
			return initialState;
		case CHUNK_LOADING_ERROR:
			return {
				...state,
				chunkLoadingErrors: state.chunkLoadingErrors.concat([
					{ error: action.error, component: action.component },
				]),
			};
		case NETWORK_SAVE_REQUEST_ERROR:
			if (state.outgoingSaveRequestFailed) {
				return state;
			}

			return {
				...state,
				outgoingSaveRequestFailed: true,
			};
		case NETWORK_FETCH_REQUEST_ERROR:
			if (state.outgoingFetchRequestFailed) {
				return state;
			}

			return {
				...state,
				outgoingFetchRequestFailed: true,
			};
		case CHANGE_NETWORK_STATE:
			if (!state.online && action.online) {
				return {
					...state,
					online: true,
					requestErrors: [],
					chunkLoadingErrors: [],
				};
			}

			return {
				...state,
				online: Boolean(action.online),
			};
		default:
			return state;
	}
};
